<template>
  <div class="log-timeline">
    <div v-for="(block, i) in blocks" :key="i" class="log-timeline-row">
      <div class="log-timeline-time">
        <span class="log-timeline-time-date" v-if="splitTime(block.type === 'event' ? block.time : block.items[0].time).date">{{
          splitTime(block.type === "event" ? block.time : block.items[0].time).date
        }}</span>
        <span class="log-timeline-time-hour">{{
          splitTime(block.type === "event" ? block.time : block.items[0].time).hour
        }}</span>
      </div>
      <div class="log-timeline-marker">
        <span class="dot" :class="{ 'dot--voucher': block.type === 'voucher' }"></span>
        <span v-if="i < blocks.length - 1" class="line"></span>
      </div>

      <div v-if="block.type === 'event'" class="log-timeline-text">{{ block.text }}</div>

      <div v-else class="voucher-card" :class="`voucher-card--${block.status}`">
        <div class="voucher-card-header">
          <v-icon size="14">mdi-ticket-confirmation-outline</v-icon>
          <span class="voucher-card-code">{{ block.voucher }}</span>
          <span class="voucher-card-badge">{{ statusLabel(block.status) }}</span>
        </div>
        <div class="voucher-card-body">
          <div v-for="(item, j) in block.items" :key="j" class="voucher-card-item">
            <span class="voucher-card-item-time">
              <span v-if="splitTime(item.time).date" class="voucher-card-item-time-date">{{ splitTime(item.time).date }}</span>
              <span class="voucher-card-item-time-hour">{{ splitTime(item.time).hour }}</span>
            </span>
            <span class="voucher-card-item-text">{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const STATUS_LABEL = {
  erro: "Erro",
  resolvida: "Resolvida",
  aguardando: "Aguardando",
};

export default {
  name: "LogTimeline",
  props: {
    logs: { type: Array, required: true },
  },
  computed: {
    blocks() {
      const result = [];
      const voucherBlocks = new Map();

      this.logs.forEach((log) => {
        if (log.voucher) {
          let block = voucherBlocks.get(log.voucher);
          if (!block) {
            block = { type: "voucher", voucher: log.voucher, items: [] };
            voucherBlocks.set(log.voucher, block);
            result.push(block);
          }
          block.items.push({ time: log.time, text: log.text });
        } else {
          result.push({ type: "event", time: log.time, text: log.text });
        }
      });

      result.forEach((block) => {
        if (block.type === "voucher") block.status = this.computeStatus(block.items);
      });

      return result;
    },
  },
  methods: {
    computeStatus(items) {
      const joined = items
        .map((item) => item.text.toLowerCase())
        .join(" · ");
      if (joined.includes("erro") || joined.includes("não localizada")) return "erro";
      if (joined.includes("resolvida")) return "resolvida";
      return "aguardando";
    },
    statusLabel(status) {
      return STATUS_LABEL[status] || status;
    },
    // O log ao vivo (execução única) manda só "HH:MM". O histórico por
    // voucher (várias execuções, possivelmente dias diferentes) manda
    // "DD/MM/YYYY HH:MM" — nessa coluna estreita a data e hora juntas
    // quebravam a meio da linha. Separa em duas linhas curtas, sempre que
    // tiver data.
    splitTime(t) {
      if (!t) return { date: null, hour: "" };
      const parts = t.split(" ");
      return parts.length > 1 ? { date: parts[0], hour: parts[1] } : { date: null, hour: parts[0] };
    },
  },
};
</script>

<style src="./styles.scss" scoped lang="scss" />
